import React, { Fragment } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ListItem from '@mui/material/ListItem'
import Divider from '@mui/material/Divider'
import DecoratedListItemItems from './DecoratedListItemItems'

const DecoratedListItem = ({
  targetObject,
  index,
  deleteHandler,
  disabled,
  itemConfig,
  formikProps
}) => {
  const classes = useStyles()

  return (
    <Fragment key={index}>
      <ListItem  className={classes.listItem}>
        {/*
          New Component
          I Moved => <ListItemText primary={primaryContent} />
          into the component to be able to styled it later to match the Figma Designs
        */}
        <DecoratedListItemItems
          index={index}
          itemName={targetObject.name}
          itemConfig={itemConfig}
          onEditMode={!disabled}
          formikProps={formikProps}
          deleteHandler={deleteHandler}
        />
      </ListItem>
      <Divider variant='fullWidth' />
    </Fragment>
  )
}

export default React.memo(DecoratedListItem)

const useStyles = makeStyles({
  listItem: {
    padding: '0 auto',
    margin: '0',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& .MuiListItemText-secondary': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  deleteButton: {
    padding: '12px 0'
  },
  smImage: {
    width: 50,
    height: 50,
    '& img': {
      transform: 'scale(0.6)'
    }
  }
})
